import { render, staticRenderFns } from "./inativarFamilias.vue?vue&type=template&id=6e5795b8&scoped=true"
import script from "./inativarFamilias.vue?vue&type=script&lang=js"
export * from "./inativarFamilias.vue?vue&type=script&lang=js"
import style0 from "./inativarFamilias.vue?vue&type=style&index=0&id=6e5795b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5795b8",
  null
  
)

export default component.exports